var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overlay show"}),_c('div',{staticClass:"spanner show"},[_c('div',{staticClass:"loader"}),_c('p',[_vm._v("Veuiller patienter un moment...")])])])
}]

export { render, staticRenderFns }